import { render } from "./PromptCardInput.vue?vue&type=template&id=dacc67b2&scoped=true"
import script from "./PromptCardInput.vue?vue&type=script&lang=js"
export * from "./PromptCardInput.vue?vue&type=script&lang=js"

import "./PromptCardInput.vue?vue&type=style&index=0&id=dacc67b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dacc67b2"]])

export default __exports__